import dayjs from 'dayjs';
import MonthPicker from './month-picker';
import { get } from '../../utils';
import { rangeOptions, resetTime } from '../utils';
export default class EmbedDatePicker extends MonthPicker {
    getStep() {
        return 'day';
    }
    getDisableType() {
        return 'day';
    }
    getRangeCheck() {
        return {
            date: {
                hasYear: true,
                hasMonth: true,
                hasDay: true,
            },
        };
    }
    getDataSource(locale) {
        const result = super.getDataSource(locale);
        const dayLocale = get(locale, 'locale.DatePicker.day', '日');
        const month = this.value.getMonth();
        const year = this.value.getFullYear();
        const days = dayjs(`${year}-${month + 1}-01`).daysInMonth();
        result.push(this.filterDataSource(rangeOptions(1, days, dayLocale), (d, it) => {
            resetTime(d);
            d.setFullYear(year);
            d.setMonth(month, it.value);
        }, 'day'));
        return result;
    }
    toDate(values) {
        const d = super.toDate(values);
        d.setDate(values[2]);
        return d;
    }
    toValues(d) {
        const values = super.toValues(d);
        values.push(d.getDate());
        return values;
    }
}
